(function () {
  const ATTR_KEY = '_primary_handles';
  let inFlight = false;

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async function writeAttribute(value) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [ATTR_KEY]: value } }),
    });
  }

  function isBundleLine(item) {
    const props = item.properties;
    if (!props) return false;
    if (Array.isArray(props)) {
      return props.some((p) => Array.isArray(p) && p[0] === '_bundle' && String(p[1]) === 'true');
    }
    return String(props._bundle) === 'true';
  }

  async function syncPrimaryHandles() {
    if (inFlight) return;
    inFlight = true;
    try {
      const cart = await fetchCart();
      const existingRaw = (cart.attributes && cart.attributes[ATTR_KEY]) || '';
      const existing = existingRaw.split(',').map((s) => s.trim()).filter(Boolean);
      const set = new Set(existing);

      if (cart.item_count === 0) {
        if (set.size === 0) return;
        await writeAttribute('');
        return;
      }

      let dirty = false;
      for (const item of cart.items) {
        if (isBundleLine(item)) continue;
        if (item.handle && !set.has(item.handle)) {
          set.add(item.handle);
          dirty = true;
        }
      }
      if (dirty) await writeAttribute([...set].join(','));
    } catch (e) {
      /* noop — best-effort tracking */
    } finally {
      inFlight = false;
    }
  }

  function init() {
    syncPrimaryHandles();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        syncPrimaryHandles();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
